import {
    GetApplicationListPayloadModel,
    ISaveAnalysisResultPayload,
    IGetEscalatedDataPayload,
} from "../Models/applicationModels";
import { productQuotePayloadModel, UnlockSsnDialogPayloadModel, UpdateThreePSPayloadModel } from "../Models/tableDetailsModel";
import { requests } from "./Api";
import { ISaveAnswerApiPayload } from "../Models/thirdPartyQuestionnarieModels";

const SignInWithGoogle = {
    get: () => requests.get("/api/DevelopmentPortal/outbound-auth-url-google"),
};

const SendLoginOtp = {
    post: (email: string) =>
        requests.postSilent(
            `/api/developmentportal/send-login-otp?email=${encodeURIComponent(email)}`,
            {}
        ),
};

const VerifyLoginOtp = {
    post: (email: string, otp: string) =>
        requests.postSilent(
            `/api/developmentportal/verify-login-otp?email=${encodeURIComponent(email)}&otp=${encodeURIComponent(otp)}`,
            {}
        ),
};

const GetApplicationList = {
    get: (size: number, pageNo: number) => requests.get(`/api/developmentPortal/application-list/v1?size=${size}&pageNo=${pageNo}`),
};

const GetApplicationListV1 = {
    post: (payload: GetApplicationListPayloadModel) => requests.post("/api/developmentPortal/application-list/v1", payload),
};

const GetLNIDList = {
    get: () => requests.get("/api/developmentportal/lnid-list"),
};

const UpdateLNIDStatus = {
    put: () => requests.put("/api/developmentportal/update-lnid"),
};

const GetGenericProductQuote = {
    get: (productUID: string) => requests.get(`/api/DevelopmentPortal/product-quote-generic?proUid=${productUID}`),
};

const GetProductQuote = {
    post: (payload: productQuotePayloadModel) => requests.post(`/api/DevelopmentPortal/product-quote`, payload),
};

const UserMeCall = {
    get: () => requests.get("/api/DevelopmentPortal/me"),
};

const GetThreePsHistoryData = {
    get: (threePsApiTaxoId: number) => requests.get(`/api/DevelopmentPortal/three-ps?threePsApiTaxoId=${threePsApiTaxoId}`),
};

const GetThreePsSwitch = {
    get: () => requests.get("/api/DevelopmentPortal/currant-three-ps"),
};

const UpdateThreePs = {
    post: (payload: UpdateThreePSPayloadModel[]) => requests.post("/api/DevelopmentPortal/three-ps", payload),
};

const GetFilteredApplicationList = {
    post: (payload: any) => requests.post("/api/DevelopmentPortal/application-list", payload),
};

const GetThirdPartyQuestionnaire = {
    get: () => requests.get("/api/Documentation/get-technical-Questionnaire"),
};

const SaveThirdPartyQuestionnaireAnswers = {
    post: (payload: ISaveAnswerApiPayload[]) => requests.post("/api/Documentation/save-technical-Questionnaire", payload),
}

const CheckSubDomainAvailability = {
    get: (subDomain: string) => requests.get(`/api/Documentation/subdomain-availability?subDomain=${subDomain}`),
};

const GetDashboardData = {
    get: (startDate: string, endDate: string, productIds: string[]) => requests.get(`/api/DevelopmentPortal/get-dashboard-data/v1?startDate=${startDate}&endDate=${endDate}${productIds?.length > 0 ? productIds.map((id) => "&productIds=" + id).join("") : ""}`),
}

const GetDashboardHierarchyData = {
    get: (startDate: string, endDate: string, productIds: string[]) => requests.get(`/api/DevelopmentPortal/get-dashboard-agent-hierarchy-data/v1?startDate=${startDate}&endDate=${endDate}${productIds?.length > 0 ? productIds.map((id) => "&productIds=" + id).join("") : ""}`),
}

const GetFinalTechnicalOutcomeList = {
    get: () => requests.get("/api/DevelopmentPortal/final-technical-outcome-list"),
}

const GetAnalysisResult = {
    get: (opportunityId: string) => requests.get(`/api/DevelopmentPortal/get-analysis-results?opportunityId=${opportunityId}`),
}

const GetApplicationInfoByOpportunityId = {
    get: (opportunityId: string) => requests.get(`/api/DevelopmentPortal/get-application-by-opportunity-id?opportunityId=${opportunityId}`),
}

const SaveAnalysisResult = {
    post: (payload: ISaveAnalysisResultPayload) => requests.post("/api/DevelopmentPortal/save-analysis-results", payload),
}

const GetEscalation = {
    get: (opportunityId: string, escalationUid: string, applicationEscalationUid?: string) => requests.get(`/api/Escalation/get-escalation?opportunityid=${opportunityId}&escalationUid=${escalationUid}${applicationEscalationUid ? '&applicationEscalationUid=' + applicationEscalationUid : ""}`),
}

const RaiseEscalationPost = {
    postForm: (opportunityId: string, escalationUid: string, payload: FormData) => requests.postForm(`/api/Escalation/raise-escalation?opportunityId=${opportunityId}&escalationUid=${escalationUid}`, payload),
}

const RaiseEscalationPut = {
    putForm: (opportunityId: string, escalationUid: string, payload: FormData) => requests.putForm(`/api/Escalation/raise-escalation?opportunityId=${opportunityId}&escalationUid=${escalationUid}`, payload),
}

const UpdateSingleInsightPageRow = {
    get: (opportunityId: string) => requests.get(`/api/Escalation/get-application-with-updated-escalations?opportunityId=${opportunityId}`),
}

const UpdateEscalationStatus = {
    putForm: (applicationEscalationUid: string, status: string, formData: FormData) => requests.putForm(`/api/Escalation/update-escalation-status?applicationEscalationUid=${applicationEscalationUid}&status=${status}`, formData),
}

const GetEscalatedData = {
    post: (payload: IGetEscalatedDataPayload) => requests.post(`/api/Escalation/get-all-escalations`, payload),
}

const RefreshAutomatedNotes = {
    get: (opportunityId: string) => requests.get(`/api/DevelopmentPortal/refresh-notes?opportunityId=${opportunityId}`),
}

const UnlockApplication = {
    get: (opportunityId: string) => requests.get(`/api/ApplicationLock/unlock-application?opportunityId=${opportunityId}`),
}

const UnlockSsnApplication = {
    post: (payload: UnlockSsnDialogPayloadModel) => requests.post(`/api/ApplicationLock/unlock-ssn`, payload),
}

const GenericDevPortalUsers = {
    get: () => requests.get(`/api/escalation/get-all-users`),
}

const GenericEscalationStatuses = {
    get: () => requests.get(`/api/escalation/get-all-escalation-statuses`),
}

const GenericEscalationTypes = {
    get: () => requests.get(`/api/escalation/get-all-escalation-types`),
}

const AddEscalationComment = {
    postForm: (payload: FormData) => requests.postForm(`/api/escalationcomments/add-escalation-comment`, payload),
}

const GetEventHistory = {
    get: (opportunityUid: string) => requests.get(`/api/DevelopmentPortal/get-application-events-history?opportunityUid=${encodeURIComponent(opportunityUid)}`),
}

const agent = {
    SignInWithGoogle,
    SendLoginOtp,
    VerifyLoginOtp,
    GetApplicationList,
    GetLNIDList,
    UpdateLNIDStatus,
    GetGenericProductQuote,
    GetProductQuote,
    UserMeCall,
    GetThreePsHistoryData,
    GetThreePsSwitch,
    UpdateThreePs,
    GetFilteredApplicationList,
    GetApplicationListV1,
    GetThirdPartyQuestionnaire,
    SaveThirdPartyQuestionnaireAnswers,
    CheckSubDomainAvailability,
    GetDashboardData,
    GetDashboardHierarchyData,
    GetAnalysisResult,
    GetFinalTechnicalOutcomeList,
    SaveAnalysisResult,
    GetApplicationInfoByOpportunityId,
    GetEscalation,
    RaiseEscalationPost,
    RaiseEscalationPut,
    UpdateSingleInsightPageRow,
    UpdateEscalationStatus,
    GetEscalatedData,
    RefreshAutomatedNotes,
    UnlockApplication,
    UnlockSsnApplication,
    GenericDevPortalUsers,
    GenericEscalationStatuses,
    GenericEscalationTypes,
    AddEscalationComment,
    GetEventHistory
};

export default agent;